import $ from 'jQuery';


// Here you import all the different javascript files you create
// so that they can be bundle in a single file at the end.
import Video from './modules/video';
import CarouselSlider from './modules/carousel-slider';
import Header from './modules/header';
import Navigation from './modules/navigation';
import Animation from './modules/animation';
import ScrollLink from './modules/scroll-link';
import SubmitForm from './modules/submit-form';


// if you want to use sass, uncomment the first import
import 'styles/less/application';
// import 'styles/sass/application.scss';


$(document).ready(() => {
  // Here you can enable the "modules" you imported
  Video.init();
  CarouselSlider.init();
  Header.init();
  Navigation.init();
  Animation.init();
  ScrollLink.init();
  SubmitForm.init();
});



// WEBPACK FOOTER //
// ./src/static/js/main.js